import React from 'react'

export default function Header() {
  return (
    <div className="header">
      <h1>
        Manage All Your Tasks Here
      </h1>
    </div>
  )
}
